import React from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { OldLearningPathPage } from 'src/pages/OldLearningPathPage';
import { NEW_LEARNING_PATH_PAGE_FF } from 'src/constants';
import { LearningPathPage } from 'src/pages/LearningPathPage/LearningPathPage';

export const LearningPathPageFFWrapper = (): React.ReactElement => {
  const isNewLearningPathPageAvailable = FeatureGates.checkGate(NEW_LEARNING_PATH_PAGE_FF);

  if (isNewLearningPathPageAvailable) {
    return <LearningPathPage />;
  }

  return <OldLearningPathPage />;
};
